import { useCallback, useEffect, useState } from "react";
import { ArrowClockwise, Trash, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, fmtError } from "../lib/api";
import { Button } from "./ui/button";

export default function CorrectionMaintenanceBlock() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/omr/corrections/orphaned/summary");
      setData(response.data || {});
    } catch (error) {
      toast.error("Falha ao verificar correções sem prova: " + fmtError(error));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const cleanup = async () => {
    if (!window.confirm("Remover definitivamente cartões nunca vinculados e cartões de provas já apagadas?")) return;
    setDeleting(true);
    try {
      const response = await api.delete("/omr/corrections/orphaned");
      toast.success(`${response.data.deleted || 0} correção(ões) sem prova removida(s).`);
      await load();
    } catch (error) {
      toast.error("Falha ao apagar correções sem prova: " + fmtError(error));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <section className="border border-border bg-card mb-6" data-testid="admin-correction-maintenance">
      <div className="border-b border-border px-6 py-4 flex items-center justify-between gap-4">
        <div><div className="label-eyebrow">manutenção de dados</div><h2 className="font-display text-2xl font-bold tracking-tight mt-1">Correções sem prova válida</h2></div>
        <Warning size={26} weight="duotone" className="text-[hsl(var(--warning))]" />
      </div>
      <div className="p-6 flex flex-col lg:flex-row lg:items-center justify-between gap-5">
        <div>
          <div className="font-display text-4xl font-black">{loading ? "…" : (data?.orphaned_found || 0)}</div>
          <p className="text-sm text-muted-foreground mt-2">Inclui cartões nunca vinculados e cartões de provas já apagadas. Eles não entram nos indicadores.</p>
          <div className="text-xs font-mono-data mt-2">{data?.unassigned_found || 0} sem vínculo · {data?.missing_exam_found || 0} de provas apagadas</div>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" className="rounded-none" onClick={load} disabled={loading}><ArrowClockwise size={16} className="mr-2" />Atualizar</Button>
          <Button variant="outline" className="rounded-none border-destructive text-destructive hover:text-destructive" onClick={cleanup} disabled={deleting || loading || !data?.orphaned_found}><Trash size={16} className="mr-2" />{deleting ? "Apagando…" : "Apagar correções sem prova"}</Button>
        </div>
      </div>
    </section>
  );
}
